var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.closedLocations),function(location){return _c('div',{key:location.id,staticClass:"text-white text-center bg-primary banner-container",class:{
      'q-mb-lg': _vm.$q.screen.width >= 1440,
      'q-mb-md': _vm.$q.screen.width >= 600,
      'q-mb-sm': _vm.$q.screen.width < 600,
    }},[_c('div',{staticClass:"q-py-sm text-weight-medium"},[_vm._v("\n      "+_vm._s(location.closedReason)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }